/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module isStringType
 */

export default function isStringType(value) {
  return typeof value === 'string';
}
